export const SOCKET_CLOSE_CODES = {
  // https://github.com/Luka967/websocket-close-codes
  NORMAL_CLOSURE: 1000,
  GOING_AWAY: 1001,
  PROTOCOL_ERROR: 1002,
  UNSUPPORTED_DATA: 1003,
  NO_STATUS_RECEIVED: 1005,
  ABNORMAL_CLOSURE: 1006,
  INVALID_FRAME_PAYLOAD: 1007,
  POLICY_VIOLATION: 1008,
  MESSAGE_TOO_BIG: 1009,
  MANDATORY_EXTENSION: 1010,
  INTERNAL_SERVER_ERROR: 1011,
  TLS_HANDSHAKE: 1015,
  TOKEN_EXPIRED: 3000,

  // Пользовательские коды приложения (>4000)
  FORBIDDEN: 4003,
  CONNECTION_LIMIT: 4029, // Лимит соединений исчерпан
} as const;

export type SocketCloseCode =
  typeof SOCKET_CLOSE_CODES[keyof typeof SOCKET_CLOSE_CODES];

// Коды, после которых reconnect **не выполняется**
export const SOCKET_CLOSE_CODES_NO_RECONNECT: SocketCloseCode[] = [
  SOCKET_CLOSE_CODES.FORBIDDEN,
  SOCKET_CLOSE_CODES.POLICY_VIOLATION,
];

// Коды, при которых можно делать reconnect
export const SOCKET_CLOSE_CODES_CAN_RECONNECT: SocketCloseCode[] = [
  SOCKET_CLOSE_CODES.NORMAL_CLOSURE,
  SOCKET_CLOSE_CODES.GOING_AWAY,
  SOCKET_CLOSE_CODES.PROTOCOL_ERROR,
  SOCKET_CLOSE_CODES.UNSUPPORTED_DATA,
  SOCKET_CLOSE_CODES.ABNORMAL_CLOSURE,
  SOCKET_CLOSE_CODES.INTERNAL_SERVER_ERROR,
  SOCKET_CLOSE_CODES.TLS_HANDSHAKE,
];
